<template>
  <div class="wish">
    <div>
      <div class="row">
        <div class="col name">
          <span>{{wish.name}}</span>
        </div>

        <div class="col-4 value">
          {{wish.value | currency}}
        </div>
      </div>

      <div class="row description" v-if="wish.description">{{wish.description}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["wish"],
};
</script>

<style lang="scss" scoped>
.wish {
  display: flex;
  justify-content: center;
  align-items: center;

  & > *:not(.checkbox) {
    flex: 1;
  }

  .name {
    font-weight: 400;
  }

  .value {
    font-weight: 1;
    text-align: right;
  }

  .checkbox {
    padding: 0px 15px;
  }

  .description {
    color: gray;
    font-size: 0.8rem;
  }

  .above {
    color: red;
  }
}
</style>